<template>
  <ValidationProvider
    :rules="validationRule"
    v-slot="{ errors, dirty, valid, classes }"
    tag="div"
    class="form-group"
  >
    <div>
      <label :for="name" :class="[classes, labelClass]"> {{ label }} </label>
      <input
        :name="name"
        class="form-control"
        :class="classes"
        :type="inputType"
        :placeholder="placeholder"
        :value="value"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
      />
      <div v-if="description" class="d-flex mt-3">
        <span class="mi mi-info text-info"></span>
        <p class="font-weight-normal ml-2 mb-0 text-small">{{ description }}</p>
      </div>
    </div>
    <ul class="errors">
      <li class="text-danger" v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
    </ul>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'basicInput',
  props: [
    'name',
    'label',
    'labelClass',
    'placeholder',
    'description',
    'value',
    'inputType',
    'validationRule',
    'disabled',
  ],
};
</script>

<style scoped lang="scss">
input.valid {
  color: #3c763d;
  border: 1px solid #3c763d;
  background-color: #dff0d8;
}

input.invalid {
  color: #a94442;
  border: 1px solid #a94442;
  background-color: #f2dede;
}

label {
  margin-right: 15px;
  width: auto;
  min-width: 100px;
}
</style>
